import {
  Component, Input, Output, EventEmitter, ChangeDetectionStrategy,
} from '@angular/core';
import { PaginationData } from './pagination-data.interface';

@Component({
  selector: 'ut-feed-paginator',
  templateUrl: './feed-paginator.component.html',
  styleUrls: ['./feed-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FeedPaginatorComponent {
  @Input() paginationData!: PaginationData;
  @Output() loadPage = new EventEmitter<number>();

  onPageClick(event: Event, pageNumber: number): void {
    event.preventDefault();
    this.loadPage.emit(pageNumber);
  }
}
